import React, { useState } from "react";
import { Modal, Button, Form, Spinner, Row, Col } from "react-bootstrap";
import axios from "axios";

function AddLeagueModal({ show, handleClose, onLeagueAdded }) {
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        location: "",
        logo: null,
        banner: null,
    });

    const [loading, setLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            setFormData((prev) => ({
                ...prev,
                [name]: files[0] || null,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const resetForm = () => {
        setFormData({
            name: "",
            description: "",
            location: "",
            logo: null,
            banner: null,
        });
        setErrorMessages([]);
    };

    const handleModalClose = () => {
        resetForm();
        handleClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessages([]);

        const data = new FormData();
        for (let [key, val] of Object.entries(formData)) {
            if (key === "logo" || key === "banner") {
                if (val instanceof File) {
                    data.append(key, val);
                }
            } else {
                data.append(key, val);
            }
        }

        axios
            .post("/api/leagues/add/", data, {
                withCredentials: true,
            })
            .then((response) => {
                onLeagueAdded(response.data.league);
                resetForm();
                handleClose();
            })
            .catch((error) => {
                console.error("Error adding league:", error.response?.data);

                const data = error.response?.data?.errors || error.response?.data || {};

                if (typeof data === "object") {
                    const parts = Object.entries(data).flatMap(([field, msgs]) =>
                        (Array.isArray(msgs) ? msgs : [msgs]).map(
                            (m) => `Field [${field}]: ${m}`
                        )
                    );
                    setErrorMessages(parts.length ? parts : ["An unexpected error occurred. Please try again."]);
                } else {
                    setErrorMessages(["An unexpected error occurred. Please try again."]);
                }
            })
            .finally(() => setLoading(false));
    };

    return (
        <Modal show={show} onHide={handleModalClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add League</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessages.map((err, i) => (
                    <div key={i} className="text-danger">{err}</div>
                ))}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="name">
                                <Form.Label>League Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="location">
                                <Form.Label>Location</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="location"
                                    value={formData.location}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="description">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="logo">
                                <Form.Label>Logo</Form.Label>
                                <Form.Control type="file" name="logo" onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="banner">
                                <Form.Label>Banner</Form.Label>
                                <Form.Control type="file" name="banner" onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="text-end">
                        <Button variant="secondary" onClick={handleModalClose} className="me-2">
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm" /> : "Add League"}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default AddLeagueModal;
